import { render } from "./BreadcrumbDocsComponent.vue?vue&type=template&id=41f4999c"
import script from "./BreadcrumbDocsComponent.vue?vue&type=script&lang=js"
export * from "./BreadcrumbDocsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__